import { computed, Injectable } from '@angular/core';
import { selectService } from '../../../../store/service/service.selectors';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class ServiceSettingsSpecialistRecordStore extends ComponentStoreV2Factory {

    service = toSignal(globalStore!.select(selectService));
    serviceId = computed(() => this.service()?.id);

}
